import i18next from 'i18next';

const translate =  (key) => {
    //const lang = await Storage.getItem('language') || 'en'
   return i18next.t(key)
}

export default translate